(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ActiveIntegrationController', ActiveIntegrationController);

    ActiveIntegrationController.$inject = ['Integration', 'IntegrationScope', 'TabDomains', '$state', 'pagingParams', 'paginationConstants'];

    function ActiveIntegrationController (Integration, IntegrationScope, TabDomains, $state, pagingParams, paginationConstants) {
        var vm = this;

        vm.integrations = [];
        vm.selectedDomain = {};
        vm.selectedScope = {};

        vm.charToSearch = pagingParams.search;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        vm.currentState = "active-integration";
        vm.filter = localStorage.getItem(vm.currentState);

        if(vm.filter != null && vm.filter !== "null" && vm.filter !== undefined){
            vm.filter = JSON.parse(vm.filter);
            if (Object.keys(vm.filter).length > 0) {
                if (vm.selectedDomain === vm.filter.selectedDomain || vm.selectedDomain === {}
                    || vm.selectedDomain == null || Object.keys(vm.selectedDomain).length === 0) {

                    vm.selectedDomain = vm.filter.selectedDomain;
                    vm.selectedScope = vm.filter.selectedScope;
                } else {
                    setLocalStorage();
                }
            }
        } else {
            vm.selectedDomain.id = -1;
            vm.selectedScope.scope = "All";
        }

        function setLocalStorage() {
            vm.filter = {};
            vm.filter.selectedDomain = vm.selectedDomain;
            vm.filter.selectedScope = vm.selectedScope;
            localStorage.setItem(vm.currentState, JSON.stringify(vm.filter));
        }

        vm.domains = TabDomains.query({size:1000}, function (result) {
            var all = {
                id: -1,
                domainName: "All",
            };
            vm.domains = result;
            vm.domains.unshift(all);
            vm.selectedDomain === {} ? vm.domains[0] : vm.selectedDomain;
        });

        vm.scopes = IntegrationScope.query(function (result) {
            var all = {
                id: -1,
                scope: "All",
            };
            vm.scopes = result;
            vm.scopes.unshift(all);
            vm.selectedScope === {} ? vm.scopes[0] : vm.selectedScope;
        });

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadPage (page) {
            vm.page = page;
            transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            setLocalStorage();

            $state.transitionTo($state.$current, {
                page: vm.page,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                scope: vm.selectedScope,
                search: vm.charToSearch,
                domain : vm.selectedDomain,
                filter: vm.filter
            }, {notify: notify, location: "replace"});
        }

        vm.loadAll = function(){
            var body = {
                page: pagingParams.page -1,
                size: vm.itemsPerPageChosen,
                scope: vm.selectedScope.scope,
                domainId : vm.selectedDomain.id,
                query: vm.charToSearch
            };

            Integration.query(body, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.integrations = [];
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                vm.integrations = data;
            }

            function onError(error) {}
        };

        vm.reloadIntegration = function() {
            setLocalStorage();
            vm.loadAll();
        }

        vm.loadAll();
    }
})();
